import React, { useEffect, useState } from "react";
import { ClientTab } from "./components/ClientTab";
import { TherapistTab } from "./components/TherapistTab";
import { TabButton } from "./components/TabButton";
import { Container } from "../../components";

const VALUE_PROPS = [
  "Effective Appointment Booking",
  "Health & Beauty Service Matching",
  "Wellness, Spa & Beauty Scheduling",
  "Seamless Payments & Earnings",
  "Trusted Meind Therapy Care",
];

const ROTATE_MS = 3500;
const FADE_MS = 500;

const AppointmentBooking = () => {
  const [tabToShow, setTabToShow] = useState<"client" | "hero">("client");
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (reduceMotion) return;

    let fadeTimeout: number;
    const intervalId = window.setInterval(() => {
      setIsVisible(false);

      fadeTimeout = window.setTimeout(() => {
        setActiveIndex((prev) => (prev + 1) % VALUE_PROPS.length);
        setIsVisible(true);
      }, FADE_MS);
    }, ROTATE_MS);

    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(fadeTimeout);
    };
  }, []);

  return (
    <section
      className="bg-[#F1F3FB] px-6 lg:px-12 py-12 lg:py-24 overflow-x-hidden scroll-mt-32"
      id="Features"
    >
      <Container size="lg" className="min-w-0">
        <div className="relative max-w-[600px] mx-auto mb-6 min-h-[2.5em] lg:min-h-[124px] flex items-center justify-center">
          <h2
            aria-live="polite"
            className={`text-3xl lg:text-[56px] lg:leading-[62px] tracking-tighter text-center transition-all duration-500 ease-in-out ${
              isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-2"
            }`}
          >
            {VALUE_PROPS[activeIndex]}
          </h2>
        </div>
        <p className="text-center max-w-[670px] mx-auto">
          Meind Therapy is built for the health and beauty space, helping clients
          book wellness, spa, massage, and beauty services while empowering Heros
          to grow their practice with clearer scheduling, payments, and care.
        </p>
        <div className="mt-11 rounded-lg border border-[#888888] bg-white p-2 flex gap-4 items-center w-fit mx-auto">
          <TabButton
            variant="client"
            currentTab={tabToShow}
            onClick={() => setTabToShow("client")}
          />
          <TabButton
            variant="hero"
            currentTab={tabToShow}
            onClick={() => setTabToShow("hero")}
          />
        </div>

        {/* Tabs */}
        {tabToShow === "client" ? <ClientTab /> : <TherapistTab />}
      </Container>
    </section>
  );
};

export default AppointmentBooking;
